/* These reflect the back-end PlatformBranding helper */
export const PlatformBrandingMap = {
    TE_ADDRESS_1: '1600 Utica Ave',
    TE_ADDRESS_2: 'Suite 600, 6th Floor',
    TE_CITY: 'St. Louis Park',
    TE_STATE: 'MN',
    TE_ZIPCODE: '55416',
    TE_CORPORATE_PHONE: '(800) 830-9085',
    TE_CORPORATE_PHONE_HREF: '+1-800-830-9085',
    TE_CORPORATE_LOCAL_PHONE: '(952) 977-8620',
    TE_CORPORATE_LOCAL_PHONE_HREF: '+1-952-977-8620',
    TE_CORPORATE_WEBSITE: 'www.totalexpert.com',
    TE_LOGO: '/images/logos/Total-Expert-Diamond-Full-Color.png',
    TE_LOGO_WITH_TEXT: '/images/logos/Total-Expert-Logo-Gray-Text.png',
    TE_SUPPORT_EMAIL: 'support@totalexpertinc.com',
    TE_MEDIA_SUPPORT_EMAIL: 'marketingmediateam@totalexpert.com'
}

export const FormattedPlatformBrandingMap = {
    TE_ADDRESS_LINE_1: `${PlatformBrandingMap.TE_ADDRESS_1}, ${PlatformBrandingMap.TE_ADDRESS_2}`,
    TE_ADDRESS_LINE_2: `${PlatformBrandingMap.TE_CITY} ${PlatformBrandingMap.TE_STATE} ${PlatformBrandingMap.TE_ZIPCODE}`,
    TE_ADDRESS_FULL: `${PlatformBrandingMap.TE_ADDRESS_1}, ${PlatformBrandingMap.TE_ADDRESS_2}, ${PlatformBrandingMap.TE_CITY} ${PlatformBrandingMap.TE_STATE} ${PlatformBrandingMap.TE_ZIPCODE}`,
    TE_CORPORATE_WEBSITE_HREF: `https://${PlatformBrandingMap.TE_CORPORATE_WEBSITE}`,
    TE_LOGO_HREF: `//totalexpert.net/${PlatformBrandingMap.TE_LOGO}`,
    TE_LOGO_WITH_TEXT_HREF: `//${PlatformBrandingMap.TE_LOGO_WITH_TEXT}`,
}

export const TypographyMappingMap = {
    fontList: [
        {
            name: 'Andale Mono',
            value: 'andale mono,times'
        },
        {
            name: 'Arial',
            value: 'arial,helvetica,sans-serif'
        },
        {
            name: 'Arial Black',
            value: 'arial black,avant garde'
        },
        {
            name: 'Book Antiqua',
            value: 'book antiqua,palatino'
        },
        {
            name: 'Comic Sans MS',
            value: 'comic sans ms,sans-serif'
        },
        {
            name: 'Courier New',
            value: 'courier new,courier'
        },
        {
            name: 'Georgia',
            value: 'georgia,palatino'
        },
        {
            name: 'Helvetica',
            value: 'helvetica'
        },
        {
            name: 'Impact',
            value: 'impact,chicago'
        },
        {
            name: 'Symbol',
            value: 'symbol'
        },
        {
            name: 'Tahoma',
            value: 'tahoma,arial,helvetica,sans-serif'
        },
        {
            name: 'Terminal',
            value: 'terminal,monaco'
        },
        {
            name: 'Times New Roman',
            value: 'times new roman,times'
        },
        {
            name: 'Trebuchet MS',
            value: 'trebuchet ms,geneva'
        },
        {
            name: 'Verdana',
            value: 'verdana,geneva'
        },
        {
            name: 'Lato',
            value: 'lato,tahoma,sans-serif'
        },
        {
            name: 'Open Sans',
            value: 'open sans, sans-serif'
        }
    ]
}

export const PlatformBrandingMixin = {
    data() {
        return {
            PlatformBranding: {...PlatformBrandingMap, ...FormattedPlatformBrandingMap, ...TypographyMappingMap}
        };
    }
}
